import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const Text = styled.div`
  ${({ theme, displayStyles }) =>
    renderStyledElementStyles(theme, displayStyles.elements.paragraph)}
  ${({ theme, visualStyles }) =>
    renderStyledElementStyles(theme, visualStyles.elements.paragraph)}
`;
